import { useState } from 'react';
import { makeStyles } from '@material-ui/styles';

import { useEvent } from '@bizzabo/entities';

import PrivateChat from './PrivateChat';
import { MessagesContext as MessagesContext, View } from './contexts/MessagesContext';
import useCreateChannel from './hooks/useCreateChannel';
import { createChannelAtom, showMeetingsAtom } from './atoms';
import useMessagesTabNotifications from '../hooks/useMessagesTabNotifications';
import useMessagesEnabled from '../hooks/useMessagesEnabled';
import ErrorBoundaryWrapper from '../components/ErrorBoundaryWrapper';
import useTypeTracking from '../../analytics';

interface MessagesProps {
    eventUniqueName: string;
}

const Messages: React.FC<MessagesProps> = ({ eventUniqueName }) => {
    const classes = useStyles();
    const { data: event, isLoading, isIdle } = useEvent(eventUniqueName);
    const [view, setView] = useState(View.ChannelList);
    const [searchText, setSearchText] = useState('');
    const [isEmptyState, setIsEmptyState] = useState(false);
    const { Track } = useTypeTracking({
        data: {
            category: 'DIRECT_MESSAGING',
        },
    });
    useCreateChannel({ setView });

    const onResetHandle = () => {
        setView(View.ChannelList);
    };

    if (isIdle || isLoading) {
        return null;
    }

    return (
        <div className={classes.wrapper}>
            <MessagesContext.Provider
                value={{
                    eventUniqueName,
                    eventId: event.id,
                    event: event,
                    view,
                    setView,
                    setSearchText,
                    searchText,
                    isEmptyState,
                    setIsEmptyState,
                }}
            >
                <Track>
                    <ErrorBoundaryWrapper onReset={onResetHandle}>
                        <PrivateChat />
                    </ErrorBoundaryWrapper>
                </Track>
            </MessagesContext.Provider>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        wrapper: {
            color: theme.palette.greys[700],
            height: 'calc(100% - 20px)',
            [theme.breakpoints.down('sm')]: {
                height: '100%',
            },
        },
    }),
    { classNamePrefix: Messages.name }
);

export { showMeetingsAtom, createChannelAtom, useMessagesTabNotifications, useMessagesEnabled };
export default Messages;
